export const EQUIPMENT_TRANSFER_STATUS_DRAFT = "DRAFT";
export const EQUIPMENT_TRANSFER_STATUS_SUBMITTED = "SUBMITTED";
export const EQUIPMENT_TRANSFER_STATUS_ACCEPTED = "ACCEPTED";
export const EQUIPMENT_TRANSFER_STATUS_REJECTED = "REJECTED";
export const EQUIPMENT_TRANSFER_STATUS_CANCELED = "CANCELED";
export const EQUIPMENT_TRANSFER_STATUS_PARTIALLY_RETURNED = "PARTIALLY_RETURNED";
export const EQUIPMENT_TRANSFER_STATUS_RETURNED = "RETURNED";

export const equipmentTransferStatuses = [
  {
    value: EQUIPMENT_TRANSFER_STATUS_DRAFT,
    label: "EQUIPMENT_TRANSFERS.STATUS_DRAFT",
    type: "primary",
  },
  {
    value: EQUIPMENT_TRANSFER_STATUS_SUBMITTED,
    label: "EQUIPMENT_TRANSFERS.STATUS_SUBMITTED",
    type: "info",
  },
  {
    value: EQUIPMENT_TRANSFER_STATUS_ACCEPTED,
    label: "EQUIPMENT_TRANSFERS.STATUS_ACCEPTED",
    type: "success",
  },
  {
    value: EQUIPMENT_TRANSFER_STATUS_REJECTED,
    label: "EQUIPMENT_TRANSFERS.STATUS_REJECTED",
    type: "warning",
  },
  {
    value: EQUIPMENT_TRANSFER_STATUS_CANCELED,
    label: "EQUIPMENT_TRANSFERS.STATUS_CANCELED",
    type: "danger",
  },
  {
    value: EQUIPMENT_TRANSFER_STATUS_PARTIALLY_RETURNED,
    label: "EQUIPMENT_TRANSFERS.STATUS_PARTIALLY_RETURNED",
    type: "warning",
  },
  {
    value: EQUIPMENT_TRANSFER_STATUS_RETURNED,
    label: "EQUIPMENT_TRANSFERS.STATUS_RETURNED",
    type: "success",
  },
];

export const EQUIPMENT_TRANSFER_TYPE_TEMPORARY = "TEMPORARY";
export const EQUIPMENT_TRANSFER_TYPE_PERMANENT = "PERMANENT";

export const equipmentTransferTypes = [
  {
    value: EQUIPMENT_TRANSFER_TYPE_TEMPORARY,
    label: "EQUIPMENT_TRANSFERS.TYPE_TEMPORARY",
  },
  {
    value: EQUIPMENT_TRANSFER_TYPE_PERMANENT,
    label: "EQUIPMENT_TRANSFERS.TYPE_PERMANENT",
  },
];
